<template>
  <PgTabs
    v-if="formItemsTag.length > 0"
    class="pg-form-tag"
    :type="tagType"
    v-model="active"
    :labelTips="labelTips"
    :hideHeader="formItemsTag.length === 1"
    @tab-click="switchTab"
  >
    <template v-for="item in formItemsTag">
      <PgTabPane
        class="pg-form-tag__tab"
        v-if="showTag(item)"
        :key="item.property"
        :label="item.label"
        :name="item.property"
        :lazy="item.parameter?.lazy ?? false"
      >
        <slot
          :formConfig="item.formItems"
          :property="item.property"
          :model="model"
          :extendCompileData="extendCompileData"
        >
          <PgForm
            class="pg-form-tag__form"
            :formItems="item.formItems"
            :model="model"
            :extendCompileData="extendCompileData"
          ></PgForm>
        </slot>
      </PgTabPane>
    </template>
  </PgTabs>
</template>
<script setup>
// 支持顶部标签切换的可配置表单
import { get } from '../../../utils/index'
import { watch, shallowRef, ref, computed } from 'vue'
import PgForm from './form-main.vue'
import { PgTabs, PgTabPane } from '../../tabs/index'
import { useTemplate } from '../../../hooks/index'

const props = defineProps({
  model: Object,
  formItems: {
    type: [Array, Object],
    default: null,
  },
  formItemsUrl: {
    type: String,
    default: 'rest/ezcomp/dict/form/fetch/',
  },
  formItemsCode: {
    type: String,
    default: null,
  },
  extendCompileData: {
    type: Object,
    default: null,
  },
  value: String,
  labelTips: Object,
  tagType: String,
})

const emit = defineEmits(['on-complete', 'switch-tab'])

const { getTemplateData, compileData } = useTemplate()
const compileSource = computed(() => ({ data: props.model, ...props.extendCompileData }))
const propsCompileData = getTemplateData(null, compileSource.value)
const showTag = (item) => {
  return item.visible && (!item.show || compileData(item.show, propsCompileData))
}

//获取表单配置
const getFormItems = async () => {
  if (props.formItems) {
    return props.formItems
  } else if (props.formItemsCode) {
    const [resForm] = await get(`${props.formItemsUrl}${props.formItemsCode}`)
    return resForm?.data ?? {}
  } else {
    throw '未配置表单定义formItemsCode或formItems'
  }
}

//根据表单配置中的formTag组件拆分标签
const formItemsTag = shallowRef([])
watch(
  [() => props.formItems, () => props.formItemsUrl, () => props.formItemsCode],
  async () => {
    const resFormItems = await getFormItems()
    const itemsList = Array.isArray(resFormItems) ? resFormItems ?? [] : resFormItems?.items ?? []

    formItemsTag.value = itemsList.reduce((pre, cur) => {
      if (pre.length === 0 && cur?.component?.code !== 'formTag') {
        pre.push({
          name: '生成标题',
          label: '生成标题',
          property: `formTag_${cur.property}`,
          visible: true,
          show: null,
          parameter: {},
          formItems: {
            form: Array.isArray(resFormItems) ? {} : resFormItems.form,
            items:
              cur?.componentCode === 'formTag' || cur?.component?.code === 'formTag' ? [] : [cur],
          },
        })
      } else if (cur?.componentCode === 'formTag' || cur?.component?.code === 'formTag') {
        pre.push({
          ...cur,
          formItems: {
            form: Array.isArray(resFormItems) ? {} : resFormItems.form,
            items: [],
          },
        })
        if (!props.value && cur.parameter?.active) {
          active.value = cur.parameter?.active
        }
      } else {
        pre[pre.length - 1].formItems.items.push(cur)
      }
      return pre
    }, [])
    if (!props.value) {
      active.value = formItemsTag.value?.[0]?.property
    }
    emit('on-complete')
  },
  { immediate: true }
)

const active = ref(props.value)
watch(active, () => {
  emit('input', active.value)
})
const switchTab = (name) => {
  emit('switch-tab', name)
}
</script>
<style lang="scss">
@import '../style/form-tag.scss';
</style>
